import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer, Subject } from "rxjs";
import { ApiService } from "../services/api.service";
import { ApiServiceDelegate } from "../models/api-service-delegate";
import { NzMessageService } from "ng-zorro-antd/message";
import { LoginComponent } from "../login/login.component";
import { ApiCollection } from "../providers/api-collection";
import { TaskResponseModel, UserResponseModel, } from "../models/task.model";
import { CityResponseModel, Client, ClientAddressTypeResponseModel, ClientResponseModel, Country, CountryCodeResponseModel, CountryResponseModel, StateResponseModel } from "../models/client.model";
import { ClientsComponent } from "../pages/clients/clients.component";
import { ClientDrawerComponent } from "../components/client-drawer/client-drawer.component";
import { ClientAddPocComponent } from "../components/client-add-poc/client-add-poc.component";
import { ClientAddAddressComponent } from "../components/client-add-address/client-add-address.component";
import { ClientPocDetailComponent } from "../components/client-poc-detail/client-poc-detail.component";
import { ClientAddressDetailComponent } from "../components/client-address-detail/client-address-detail.component";
import { ConsoleClientTabComponent } from "../components/console-client-tab/console-client-tab.component";
import { CpdPeopleComponent } from "../components/console-project-detail/cpd-people/cpd-people.component";
import { EventResponseModel } from "../models/event.model";

@Injectable({
    providedIn: "root",
})

export class ClientViewModel {
    cpdPeopleComponent:CpdPeopleComponent
    parentClientsComponent: ClientsComponent;
    parentClientDrawerComponent: ClientDrawerComponent;
    clientAddPocComponent:ClientAddPocComponent
    clientAddAddressComponent:ClientAddAddressComponent
    parentClientPocDetailComponent: ClientPocDetailComponent;
    parentClientAddressDetailComponent: ClientAddressDetailComponent;
    parentConsoleClientTabComponent: ConsoleClientTabComponent;

    constructor(
        private apiService: ApiService,
        private message: NzMessageService
    ) { }

    errorService = new Subject();
    clientDataList = new BehaviorSubject<ClientResponseModel>(new ClientResponseModel());
    client = new Subject<Client>();
    userList = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
    countryList = new BehaviorSubject<CountryResponseModel>(new CountryResponseModel());
    stateList = new BehaviorSubject<StateResponseModel>(new StateResponseModel());
    cityList = new BehaviorSubject<CityResponseModel>(new CityResponseModel());
    clientAddressTypeList = new BehaviorSubject<ClientAddressTypeResponseModel>(new ClientAddressTypeResponseModel());
    countryCodeList = new BehaviorSubject<CountryCodeResponseModel>(new CountryCodeResponseModel())
    regionList = new BehaviorSubject<any>({ results: [] });
    verticalList = new BehaviorSubject<any>({ results: [] });
    eventResponseModel = new BehaviorSubject<EventResponseModel>(new EventResponseModel())

    subscribeToClients(observer: Observer<ClientResponseModel>) {
        this.clientDataList.subscribe(observer)
    }

    /* Helper function to format backend validation errors for display.
  * @param errors The error object from the backend.
  * @returns A string containing formatted error messages.
  */
    private formatBackendErrors(errors: any): void {
        let errorMessages = '';
        if (typeof errors === 'object') {
            for (const key in errors) {
                if (errors.hasOwnProperty(key)) {
                    errorMessages += `<strong>${key}:</strong> ${Array.isArray(errors[key]) ? errors[key].join(', ') : errors[key]}<br>`;
                }
            }
        } else {
            errorMessages = errors.toString();
        }
        this.message.error(errorMessages, { nzDuration: 1500 });
        // return errorMessages;
    }

    getClientList(page: number, page_size: number, name: string = '',filterObject:any={}) {
        let url = ApiCollection.Client + '?page=' + page + '&page_size=' + page_size + '&sort_by=id&sort_type=desc';
        if (name.length > 0) {
            url += '&name=' + name;
        }
        for(const [key, value ] of Object.entries(filterObject)){
            if(value != null && value != undefined && value != ''){
                if(Array.isArray(value)){
                    // Multi-select filters share the existing single-value query key; selected
                    // ids are joined with a comma into one value rather than repeating the key.
                    if(value.length > 0){
                        url += '&' + key + '=' + value.join(',')
                    }
                } else{
                    url += '&' + key + '=' + value
                }
            }
          }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.clientDataList.next(e);
                this.parentClientsComponent.clientsReceived();
                return e;
            },
            Error: (e: String) => {
                this.errorService.next(e)
                this.message.success("Client loaded unsuccessfully", { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }



    getClientByID(id: number, caller: string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Client + '/' + id,
            Success: (e: any) => {
                this.client.next(e);
                if(caller === 'app-console-client-tab'){
                    this.parentConsoleClientTabComponent.clientDataReceived();
                }

                return e;
            },
            Error: (e: String) => {
                if(caller === 'app-console-client-tab'){
                    this.parentConsoleClientTabComponent.clientDataReceivedError();
                }
                const allErrors = Object.values(e).flat();
                allErrors.forEach(element => {
                    this.message.error(String(element), { nzDuration: 2000 });
                });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteClientByID(id: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.Client + '/' + id,
            Success: (e: any) => {
                this.message.success("Client deleted successfully", { nzDuration: 1000 });
                this.parentConsoleClientTabComponent.clientDeleted();
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createPOC(data: any,caller:any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.ClientPOC,
            Success: (e: any) => {
                if(caller == 'project-details'){
                    this.cpdPeopleComponent.cancel()
                }
                if(caller == 'add-poc'){
                    this.clientAddPocComponent.pocCreated(e)
                }
                this.message.success("Client POC created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: any) => {
                this.formatBackendErrors(e)
                // this.message.error(String(e), {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updatePOC(data: any, id: number,caller:string) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.ClientPOC + '/' + id,
            Success: (e: any) => {
                if(caller == 'add-poc' ){
                    this.clientAddPocComponent.pocUpdated()
                }
                if(caller == 'add-poc-detail'){
                    this.parentClientPocDetailComponent.pocUpdated()
                }
                this.message.success("Client POC updated successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: any) => {
                this.formatBackendErrors(e)
                // this.message.error(String(e), {nzDuration: 1000});
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deletePOC(id: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.ClientPOC + '/' + id,
            Success: (e: any) => {
                this.parentClientPocDetailComponent.pocDeleted(id);
                this.message.success("Client POC deleted successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                // this.message.error(String(e), {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createClientAddress(data:any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Client_Address ,
            Success: (e: any) => {
                this.clientAddAddressComponent.addressCreated(e)
                this.message.success("Client Address created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                // this.message.success("Client loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }



    updateClientAddress(data:any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.Client_Address + '/' + data.id ,
            Success: (e: any) => {
                this.clientAddAddressComponent.addressCreated(e)
                this.message.success("Client Address update successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                // this.message.success("Client loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

      getCountryCodeList() {
        let src = ApiCollection.Country_Code + '?page=1&page_size=1000' ;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: src,
            Success: (e: any) => {
                this.countryCodeList.next(e)
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getRegionList(name?: string) {
        let src = ApiCollection.Region + '?page=1&page_size=1000';
        if (name && name.trim().length > 0) {
            src += '&name=' + name.trim();
        }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: 'GET',
            Action: src,
            Success: (e: any) => {
                this.regionList.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getVerticalList(name?: string) {
        let src = ApiCollection.Vertical + '?page=1&page_size=1000';
        if (name && name.trim().length > 0) {
            src += '&name=' + name.trim();
        }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: 'GET',
            Action: src,
            Success: (e: any) => {
                this.verticalList.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteClientAddress(id: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.Client_Address + '/' + id,
            Success: (e: any) => {
                this.parentClientAddressDetailComponent.addressDelete(id);
                this.message.success("Client Address deleted successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                // this.message.error(String(e), {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }



    getUserList(page: number, page_size: number, isSalesPerson: boolean = false) {
        let url = ApiCollection.User + '?page=' + page + '&page_size=' + page_size + '&is_deleted=false';

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                if (isSalesPerson) {
                    const results = (e?.results || []).filter((user: any) =>
                        user?.is_sales_person === true ||
                        user?.is_sales_person === 'true'
                    );
                    this.userList.next({ ...e, count: results.length, results })
                } else {
                    this.userList.next(e)
                }
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getClientAddressTypeList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Client_Address_Type + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.clientAddressTypeList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getCountryList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Country + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.countryList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

   getStateListById(page: number, page_size: number, id?: number,name?:string) {
        let url = ApiCollection.State + '?page=' + page + '&page_size=' + page_size
        if (id) {
            url += '&country=' + id
        }
        if(name){
            url += '&name=' + name
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.stateList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getCityListById(page: number, page_size: number, id?: number,name?:string) {
        let url = ApiCollection.City + '?page=' + page + '&page_size=' + page_size
        if(id){
            url += '&state=' + id
        }
        if(name){
            url += '&name=' + name
        }
        console.log(url)
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:url,
            Success: (e: any) => {
                this.cityList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }


    createClient(data: any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Client,
            Success: (e: any) => {
                this.parentClientDrawerComponent.successUpdateCreate(e);
                this.message.success("Client created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: any) => {
                this.formatBackendErrors(e)
                // const allErrors = Object.values(e).flat();
                // allErrors.forEach(element => {
                //     this.message.error(String(element), { nzDuration: 2000 });
                // });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateClient(data: any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.Client + '/' + data.id,
            Success: (e: any) => {
                this.parentClientDrawerComponent.successUpdateCreate(e);
                this.message.success("Client updated successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                // const allErrors = Object.values(e).flat();
                // allErrors.forEach(element => {
                //     this.message.error(String(element), { nzDuration: 2000 });
                // });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getEvents(page: number, page_size: number, name?: string,status?: number,client?:number) {
        let src = ApiCollection.Event + '?page=' + page + '&page_size=' + page_size +  '&sort_by=start_datetime';
        if (name?.length > 0) {
            src += '&event_name=' + name
        }
        if (status > 0 || status!= null ) {
            src += '&status=' + status
        }
        if (client) {
            src += '&client=' + client
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: src,
            Success: (e: any) => {
                this.eventResponseModel.next(e)
                // this.parentConsoleClientTabComponent.eventdataRecieved()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }


}
